/** 默认banner风格 */
export const STYLE_NORMAL = () => ({
  bannerColor: '#3265DE',
  textColor: '#fff',
  logo: null
})
